export default "__VITE_ASSET__ed1e2d96__"